import React from 'react';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import Link from 'components/Link/Link';
import { RenderRhsData } from 'routes/newslisting/layouts/desktop/photolist/RenderComponent';
import AtfContent from 'routes/newslisting/components/common/AtfContent/AtfContent';
import s from '../BoardListing/BoardListing.scss';
import Morebtn from '../../desktop/Morebtn';
import BoardListing from '../BoardListing/BoardListing';

const RenderPageComponent = ({ title, atfContent, items }) => (
  <>
    <div className={s.h1tag}>{title}</div>
    <div className={s.boardListing}>
      <div className={s.listingAtf}>
        <AtfContent content={atfContent} />
      </div>
      <div className={`${s.allBoardPages} ${s.checkResult} white_wrap`}>
        <div className={s.boardCardWrapper}>
          {items &&
            Array.isArray(items) &&
            items.length > 0 &&
            items.map(board => (
              <div className={`${s.boardCard} ${s.active}`}>
                <Link to={board?.overridelink}>
                  <div className={s.boardhead}>
                    <div className={s.heading}>{board.title}</div>
                    <div className={s.desc}>
                      {board?.metainfo?.CARDPAGETEMPLATE?.value}
                    </div>
                  </div>
                </Link>
                {board &&
                board?.metainfo &&
                board?.metainfo?.CARDPAGECODE &&
                board?.metainfo?.CARDPAGECODE?.value ? (
                  <Morebtn
                    moreText="CHECK YOUR RESULT"
                    moreLink={board?.overridelink}
                    fullWidth
                    redBrdr
                    smallSize
                    wrapperClass={s.morebtnWrapper}
                  />
                ) : (
                  <div className={s.message}>Results to be announced</div>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  </>
);

const BoardResultListing = props => {
  const {
    isPrime,
    items,
    isWapView,
    moreBoardResult,
    rhsData,
    atfContent,
    title,
  } = props;

  const renderRhsComponent = rhsWidgetData => {
    // const { isPrime } = this.props;
    if (Array.isArray(rhsWidgetData)) {
      const rdata = isPrime
        ? rhsWidgetData.filter(v => v && v?.tn !== 'ad')
        : rhsWidgetData;
      if (Array.isArray(rdata) && rdata.length) {
        return rdata.map(data => RenderRhsData(data, data?.tn));
      }
    }
    return null;
  };

  const rhsComp = renderRhsComponent(rhsData);
  const pageComponent = (
    <RenderPageComponent title={title} atfContent={atfContent} items={items} />
  );
  return (
    <>
      {isWapView || isPrime ? (
        pageComponent
      ) : (
        <div className={s.photolistBody}>
          <div className={s.lhs}>{pageComponent}</div>
          <div className={`${s.leftColSpacing}`}>
            <div className={s.rhsstickybox}>{rhsComp}</div>
          </div>
        </div>
      )}
      <div className={s.mt40_24}>
        <Listingheader
          headingname="Check out other board results"
          headingType="h2"
          size="medium18"
        />
        <BoardListing items={moreBoardResult} />
      </div>
    </>
  );
};

export default BoardResultListing;
